export default "__VITE_ASSET__DZ5vfQ0g__"